module.exports = __webpack_public_path__ + "static/indycode19-133cfca0ec0b82960d8d6a01620ce624.jpeg";